// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__K-4m7","root":"styles_root__WgfNX"};